var _filter, _filter2, _filter3, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _mask, _path, _g, _path2, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 109,
    viewBox: "0 0 108 109",
    width: 108,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 102.045,
    width: 103.025,
    x: 0.472473,
    y: 0.432922
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1_592",
    stdDeviation: 12
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 128.729,
    width: 128.729,
    x: 3.27148,
    y: 4.271
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_592",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 66.767,
    width: 36.928,
    x: 49.1711,
    y: 35.1769
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_592"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_1_592",
    mode: "normal",
    result: "effect2_dropShadow_1_592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_592",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 42.023,
    x2: 62.3995,
    y1: 15.1882,
    y2: 91.2343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc94ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f66ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8038,
    x2: 91.0243,
    xlinkHref: "#e",
    y1: 38.443,
    y2: 100.642
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 67.6359,
    x2: 61.2602,
    y1: 52.2508,
    y2: 51.7468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 65.274,
    x2: 75.894,
    xlinkHref: "#e",
    y1: 54.4603,
    y2: 56.9387
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m64.2104 53.6409c0 1.8856 1.5352 3.4247 3.3854 3.4247 1.9682 0 3.5034-1.5391 3.5034-3.4247 0-1.9288-1.5352-3.464-3.4247-3.464-1.9289 0-3.4641 1.5352-3.4641 3.464zm3.3854 33.303c1.9289 0 3.4641-1.5352 3.4641-3.4247v-17.399c0-1.8935-1.5352-3.4641-3.4641-3.4641-1.8894 0-3.4247 1.5706-3.4247 3.4641v17.399c0 1.8895 1.5353 3.4247 3.4247 3.4247z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.525 10.7665-32.9659 8.8332c-12.8898 3.4538-19.1343 14.8262-15.5277 28.2864l8.3248 31.0686c3.5965 13.4221 14.6895 20.1449 27.5793 16.6911l32.966-8.8332c12.8898-3.4538 19.0973-14.8122 15.5008-28.2344l-8.3248-31.0686c-3.6066-13.4601-14.6627-20.19688-27.5525-16.7431z",
    fill: "url(#d)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#8237ff",
    fillOpacity: 0.5,
    height: 52.1862,
    rx: 19,
    transform: "matrix(-.25881905 -.96592583 .96592583 -.25881905 -37.935885 136.377172)",
    width: 50.7999,
    x: 33.355,
    y: 82.7432
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m45.0223 39.6149c.488 1.8214 2.3693 2.9107 4.1564 2.4319 1.9011-.5095 2.9857-2.3935 2.4977-4.2148-.4993-1.8631-2.3795-2.9487-4.2046-2.4596-1.8631.4992-2.9487 2.3794-2.4495 4.2425zm11.89 31.2932c1.8631-.4992 2.9487-2.3794 2.4596-4.2045l-4.5032-16.8062c-.49-1.8289-2.3794-2.9487-4.2426-2.4495-1.8251.4891-2.9014 2.4035-2.4114 4.2324l4.5032 16.8062c.489 1.8251 2.3693 2.9107 4.1944 2.4216z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.7199 29.271h-34.1288c-13.3445 0-22.3196 9.3687-22.3196 23.3037v32.1646c0 13.8956 8.9751 23.2607 22.3196 23.2607h34.1288c13.3446 0 22.2801-9.3651 22.2801-23.2607v-32.1646c0-13.935-8.9355-23.3037-22.2801-23.3037z",
    fill: "#ba90ff",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.7199 28.771h-34.1288c-6.7937 0-12.5091 2.3876-16.5251 6.5804-4.0142 4.1909-6.2945 10.1474-6.2945 17.2233v32.1646c0 7.0565 2.2805 13.0022 6.2947 17.1867 4.016 4.187 9.7313 6.574 16.5249 6.574h34.1288c6.7937 0 12.4994-2.387 16.5061-6.574 4.004-4.1851 6.274-10.1308 6.274-17.1867v-32.1646c0-7.0753-2.27-13.0317-6.274-17.2229-4.0065-4.1932-9.7123-6.5808-16.5061-6.5808z",
    stroke: "url(#f)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m64.2104 53.6409c0 1.8856 1.5352 3.4247 3.3854 3.4247 1.9682 0 3.5034-1.5391 3.5034-3.4247 0-1.9288-1.5352-3.464-3.4247-3.464-1.9289 0-3.4641 1.5352-3.4641 3.464zm3.3854 33.303c1.9289 0 3.4641-1.5352 3.4641-3.4247v-17.399c0-1.8935-1.5352-3.4641-3.4641-3.4641-1.8894 0-3.4247 1.5706-3.4247 3.4641v17.399c0 1.8895 1.5353 3.4247 3.4247 3.4247z",
    fill: "url(#g)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.5958 56.6656c-1.6259 0-2.9854-1.3567-2.9854-3.0247h-.8c0 2.1032 1.711 3.8247 3.7854 3.8247zm3.1034-3.0247c0 1.6591-1.3505 3.0247-3.1034 3.0247v.8c2.1834 0 3.9034-1.7126 3.9034-3.8247zm-3.0247-3.064c1.6656 0 3.0247 1.3531 3.0247 3.064h.8c0-2.1467-1.7113-3.864-3.8247-3.864zm-3.0641 3.064c0-1.7079 1.3562-3.064 3.0641-3.064v-.8c-2.1498 0-3.8641 1.7143-3.8641 3.864zm6.0495 29.8783c0 1.6656-1.3531 3.0247-3.0641 3.0247v.8c2.1468 0 3.8641-1.7113 3.8641-3.8247zm0-17.399v17.399h.8v-17.399zm-3.0641-3.0641c1.7053 0 3.0641 1.3889 3.0641 3.0641h.8c0-2.1117-1.7116-3.8641-3.8641-3.8641zm-3.0247 3.0641c0-1.6782 1.3618-3.0641 3.0247-3.0641v-.8c-2.116 0-3.8247 1.7554-3.8247 3.8641zm0 17.399v-17.399h-.8v17.399zm3.0247 3.0247c-1.6685 0-3.0247-1.3561-3.0247-3.0247h-.8c0 2.1104 1.7143 3.8247 3.8247 3.8247z",
    fill: "url(#h)",
    mask: "url(#i)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2afde416778472f8d9bb311d5b0b435c.svg";
export { ForwardRef as ReactComponent };